export default async function stringToHash(string) {
  const utf8 = new TextEncoder().encode(string)
  if(!crypto.subtle){
    return string
  }
  return crypto.subtle.digest('SHA-256', utf8).then(hashBuffer => {
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map(bytes => bytes.toString(16).padStart(2, '0'))
      .join('')
    return hashHex
  })
}

export async function jsonToHash(json) {
  let returnJson = {}
  for (let key in json) {
    returnJson[key] = await stringToHash(json[key])
  }
  return returnJson
}
